import { enUS, ptBR } from 'date-fns/locale';
import i18n from 'i18n';

export const defaultDateFnsLocale = i18n.language === 'pt' ? ptBR : enUS;
